/* eslint-disable react/no-unknown-property */
/* eslint-disable @typescript-eslint/no-explicit-any */
import style from "../index.module.scss";
import {
  Box,
  Select,
  Avatar,
  Button,
  MenuItem,
  TextField,
  IconButton,
  InputLabel,
  FormControl,
  DialogActions,
  InputAdornment,
} from "@mui/material";
import { imageUploadApi } from "@/common-components-src/api/image/index.api";
import { imageUtil } from "@/common-components-src/js/utils/imageUtil";
import IMAGEAPI_TYPE from "@/common-components-src/const/imageApiType";
import UKToast from "@/common-components-src/components/UKToast/index";
import Cancel from "@mui/icons-material/Cancel";
import LoadingIcon from "@/app/csr-src/components/loadingIcon/index";

import dayjs from "dayjs";
import { UserInfoT } from "../types/index";
import React, { useEffect, useState } from "react";
import { convertDate, dateFormat } from "@/app/csr-src/utils/helpers";
import { DatePicker } from "@mui/x-date-pickers/DatePicker";
import { AdapterDayjs } from "@mui/x-date-pickers/AdapterDayjs";
import { getUserInfoApi, updateUserInfoApi } from "@/app/csr-src/apis/personal/index.api";
import { LocalizationProvider } from "@mui/x-date-pickers/LocalizationProvider";
import { InputStyle, BoxStyle, avatarUploadIcon } from "./style";
interface ContentProps {
  onContentClose?: (v: boolean) => void;
  saverSuccessFn?: () => void;
}
const ContentBox = (props: ContentProps) => {
  const { onContentClose, saverSuccessFn } = props;
  const [isLoading, setIsLoading] = useState(false);
  const [birthday, setBirthday] = useState<any>(""); // 生日选择
  const [error, setError] = useState<string | null>("");
  const [avatar, setAvatar] = useState<string | null>(""); // 头像图片
  const [username, setUsername] = useState<string | null>(""); // 用户名选输入
  const [gender, setGender] = useState<string | number | null>(""); // 性别
  useEffect(() => {
    getUserInfoFn();
  }, []);

  // 获取用户信息
  const getUserInfoFn = async () => {
    const [err, res] = await getUserInfoApi();
    if (res && res.success) {
      const data: UserInfoT = res.data; // 用户信息
      setGender(data.gender); // 性别
      setAvatar(data.avatar); // 头像图片
      setUsername(data.nickName);
      setBirthday(data.birthday ? convertDate(data.birthday) : "");
    }
  };
  // 头像上传
  const handleAvatarChange = async (event: any) => {
    const file = event.target.files[0];
    if (file) {
      if (file && file.size > 5242880) {
        UKToast.show({
          icon: "error",
          content: "Please upload an image no larger than 5MB",
        });
        return;
      }

      imageUploadApi(file, IMAGEAPI_TYPE.PersonalInfo).then((res: any) => {
        if (res && res.msg) {
          setAvatar(res.msg); // 头像图片
        }
      });
    }
  };
  // 清空 用户名
  const closeUserName = () => {
    setError("");
    setUsername("");
  };
  // 用户名称 change
  const handleUsernameChange = (event: React.ChangeEvent<HTMLInputElement>) => {
    const value = event.target.value;
    if (value.length > 50) {
      return;
    }
    setError("");
    setUsername(value);
  };
  // 点击保存按钮
  const SaverBtn = async () => {
    if (username) {
      if (nickNameTest(username)) {
        updateUserInfoFn();
      } else {
        setError("Your input contains invalid characters minecraft");
      }
    } else {
      updateUserInfoFn();
    }
  };
  const nickNameTest = (nickname: string) => {
    const regex = /^(?!(.*admin.*))(?!.\s)[a-zA-Z0-9_.]{4,100}$/;
    if (!regex.test(nickname)) {
      return false;
    }
    return true;
  };
  // 修改用户信息；
  const updateUserInfoFn = async () => {
    const data: any = {};
    gender && (data.gender = gender);
    if (gender == 0) {
      data.gender = gender;
    }
    avatar && (data.avatar = avatar);
    birthday && (data.birthday = birthday);
    username && (data.nickName = username);
    setIsLoading(true);
    try {
      const [err, res] = await updateUserInfoApi(data);
      if (res && res.success) {
        UKToast.show({
          content: res?.msg || "successfully",
          icon: "success",
        });
        saverSuccessFn && saverSuccessFn();
        setIsLoading(false);
      } else {
        UKToast.show({
          content: res?.msg,
          icon: "error",
        });
        setIsLoading(false);
      }
    } catch (error) {
      console.error("Error:", error);
      setIsLoading(false);
    }
  };
  // 关闭弹框
  const handleClose = () => {
    onContentClose && onContentClose(false);
  };

  const avatarFn = (v: string | null) => {
    const a = "";
    if (v) {
      if (v.startsWith("http://") || v.startsWith("https://")) {
        return v;
      } else {
        return imageUtil.concatImgUrlWithoutForceHttps(v);
      }
    }
    return a;
  };
  return (
    <div className={style.personalInfoSetDialogContent}>
      <div className={style.assetsBox}>
        <Avatar
          src={avatarFn(avatar)}
          // src={avatar ? "" : ""}
          className={style.assetsBox__image}
          alt=""
          sx={{
            bgcolor: "#E1E3E6",
            "& .MuiSvgIcon-root": {
              width: "100%",
              height: "100%",
              fill: "#F0F1F2",
            },
          }}
        />
        <div className={style.assetsTakePictures}>
          <input
            className={style.imageInput}
            accept="image/*"
            id="avatar-upload"
            onChange={handleAvatarChange}
            type="file"
          />
          <div className={style.uploadIcon}>{avatarUploadIcon}</div>
        </div>
      </div>

      <div className={style.FormBox}>
        <Box sx={BoxStyle}>
          <TextField
            fullWidth
            multiline
            size="small"
            margin="normal"
            name="userName"
            label="User Name"
            variant="outlined"
            value={username}
            error={!!error}
            helperText={error}
            maxRows={5}
            onChange={(e: React.ChangeEvent<HTMLInputElement>) => handleUsernameChange(e)}
            aria-describedby="custom-css-outlined-input"
            slotProps={{
              input: {
                endAdornment: (
                  <InputAdornment
                    position="end"
                    sx={{ "& .MuiIconButton-root": { right: "-10px" } }}
                  >
                    {username ? (
                      <>
                        <IconButton
                          onClick={closeUserName}
                          sx={{
                            "& .MuiSvgIcon-root": { padding: 0 },
                          }}
                        >
                          <Cancel sx={{ fontSize: 18 }} />
                        </IconButton>
                      </>
                    ) : null}
                  </InputAdornment>
                ),
              },
            }}
            sx={{
              ...InputStyle,
              "&.MuiInputBase-input": {
                minHeight: 72, // Set a minimum height for the input field
              },
            }}
          />
          <LocalizationProvider dateAdapter={AdapterDayjs} adapterLocale="en-gb">
            <DatePicker
              sx={{
                ...InputStyle,
                width: "100%",
                margin: "6px 0",
                "& .MuiInputBase-root": {
                  width: "100% !important",
                  color: "info",
                },
              }}
              label="Birth date"
              format="D MMM YYYY"
              views={["year", "month", "day"]}
              value={birthday ? dayjs(birthday) : null}
              disableFuture
              onChange={(newValue: any) => {
                setBirthday(dateFormat(newValue));
              }}
            />
          </LocalizationProvider>

          {/* 性别选项 */}
          <FormControl fullWidth margin="normal" variant="outlined" size="small" sx={InputStyle}>
            <InputLabel id="gender-select-label">Gender</InputLabel>
            <Select
              labelId="gender-select-label"
              name="gender"
              label="Gender"
              value={gender}
              onChange={(event) => {
                console.log(event.target.value, "gender");
                setGender(event.target.value);
              }}
            >
              <MenuItem value={1}>Male</MenuItem>
              <MenuItem value={2}>Female</MenuItem>
              <MenuItem value={3}>Other</MenuItem>
              <MenuItem value={0}>Prefer not to say</MenuItem>
            </Select>
          </FormControl>
        </Box>
      </div>
      <DialogActions
        sx={{ padding: "20px 0", width: "100%", display: "flex", justifyContent: "right" }}
      >
        <Button
          variant="contained"
          disableElevation
          onClick={handleClose}
          sx={{
            width: "94px",
            height: "32px",
            backgroundColor: "#00000000", // 自定义背景颜色
            color: "#1a1a1a", // 自定义文字颜色
            textTransform: "none",
            border: "1px solid #E0E1E5",
            "&:hover": {
              backgroundColor: "#E0E1E5", // 悬停时的背景颜色
            },
          }}
        >
          Cancel
        </Button>
        <Button
          variant="contained"
          disableElevation
          onClick={SaverBtn}
          disabled={isLoading}
          startIcon={isLoading ? <LoadingIcon /> : null}
          sx={{
            width: "82px",
            height: "32px",
            backgroundColor: "#FF0F23", // 自定义背景颜色
            color: "#fff", // 自定义文字颜色
            textTransform: "none",
            "&:hover": {
              backgroundColor: "#FF475D", // 悬停时的背景颜色
            },
            "&.Mui-disabled": {
              backgroundColor: "#FF9FA7",
              color: "#fff",
            },
          }}
        >
          Save
        </Button>
      </DialogActions>
    </div>
  );
};

export default ContentBox;
